import { ReactNode } from 'react';
import ConversationProviderContext from '../contexts/conversation-context';

interface IConversationProviderProps {
  children: ReactNode;
}

const conversationId = createConversationId();

function ConversationProvider({ children, ...props }: IConversationProviderProps) {
  return (
    <ConversationProviderContext.Provider {...props} value={{ conversationId }}>
      {children}
    </ConversationProviderContext.Provider>
  );
}

function createConversationId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`
  );
}

export default ConversationProvider;
